import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { api, setAuthToken } from "../lib/api";

const STORAGE_KEY = "admin_token";
const inputClass = "bg-slate-950 border-slate-800 text-slate-100 placeholder:text-slate-500";

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("admin");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem(STORAGE_KEY);
    if (token) {
      setAuthToken(token);
      navigate("/admin");
    }
  }, [navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      setSubmitting(true);
      const res = await api.post("/auth/login", { username, password });
      const token = res?.data?.access_token;
      if (!token) throw new Error("Token ausente");
      localStorage.setItem(STORAGE_KEY, token);
      setAuthToken(token);
      toast.success("Login realizado");
      navigate("/admin");
    } catch (err) {
      toast.error("Usuário ou senha inválidos");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center px-4">
      <Card className="w-full max-w-md border-slate-800 bg-slate-900 text-white">
        <CardContent className="p-6">
          <h1 className="text-2xl font-bold mb-2">Admin</h1>
          <p className="text-sm text-slate-300 mb-6">Entre para editar o conteúdo do site.</p>

          <form onSubmit={onSubmit} className="space-y-4">
            <div className="space-y-2">
              <label className="text-sm text-slate-200">Usuário</label>
              <Input
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="username"
                className={inputClass}
              />
            </div>
            <div className="space-y-2">
              <label className="text-sm text-slate-200">Senha</label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                className={inputClass}
              />
            </div>
            <Button disabled={submitting} className="w-full bg-orange-500 hover:bg-orange-600">
              {submitting ? "Entrando..." : "Entrar"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
